module.exports = __webpack_public_path__ + "img/confetti_3b.f5ab31ed.svg";